// extracted by mini-css-extract-plugin
export default {"container":"mJFPwG885hg8knoVA5QM"};